import React from "react";

interface EditCalendarIconProps {
  className?: string;
  size?: number;
  color?: string;strokeWidth?: number; strokeWidth2?: number;
}

const EditCalendarIcon: React.FC<EditCalendarIconProps> = ({
  size = 16,
  color = '#1E1E1E',
}) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5.33337 1.33398V3.33398" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M10.6666 1.33398V3.33398" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M2.33337 6.06055H13.6667" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12.8087 10.5129L10.4487 12.8729C10.3554 12.9662 10.2687 13.1395 10.2487 13.2662L10.1221 14.1662C10.0754 14.4929 10.3021 14.7195 10.6287 14.6729L11.5287 14.5462C11.6554 14.5262 11.8354 14.4395 11.9221 14.3462L14.2821 11.9862C14.6887 11.5795 14.8821 11.1062 14.2821 10.5062C13.6887 9.91288 13.2154 10.1062 12.8087 10.5129Z" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M12.4675 10.8535C12.6675 11.5735 13.2275 12.1335 13.9475 12.3335" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M8 14.6673H5.33333C3 14.6673 2 13.334 2 11.334V5.66732C2 3.66732 3 2.33398 5.33333 2.33398H10.6667C13 2.33398 14 3.66732 14 5.66732V8.00065" stroke={color} strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M7.9963 9.13411H8.00229" stroke={color} stroke-width="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.53023 9.13411H5.53622" stroke={color} stroke-width="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M5.53023 11.1341H5.53622" stroke={color} stroke-width="1.33333" strokeLinecap="round" strokeLinejoin="round"/>
</svg>

);

export default EditCalendarIcon;
